<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div class="member-card text-white rounded">
    <!--Name and ID-->
    <div class="card-user-details-section">
      <div class="card-user-details">
        <h3 class="card-name mb-0" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h3>
        <div class="d-flex font-size-12 mb-2 card-details text-tertiary">
          <h5>{{ memberCard.ProductCode }}</h5>
          <div class="px-1">-</div>
          <span>{{ memberCard.ExternalRefNumber }}</span>
        </div>
      </div>
      <!--Logo-->
      <div class="align-self-center">
        <img alt="" class="card-logo" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
      </div>
    </div>

    <ng-container *notInPopulation="[populations.U18]">
      <div class="points-wrapper">
        <div class="bg-glass">
          <i class="material-symbols-outlined">loyalty</i>
          <div class="points-info">
            <span class="points"> {{ pointsBalance$ | async | number: '1.0-0' }}</span>

            <span class="points-text">{{ 'member.card.points.label' | translate: { fgbdefault: 'Your Points' } }}</span>
          </div>
        </div>
        <div class="bg-glass">
          <i class="material-symbols-outlined">money_bag</i>
          <div class="points-info">
            <span class="points"> {{ ecash$ | async | FortressCurrencyPipe }}</span>
            <span class="points-text">{{ 'member.card.cashback.label' | translate: { fgbdefault: 'Cashback' } }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
